import React, { Component } from "react";
import PropTypes from "prop-types";
import { Div, Button } from "glamorous";
import styles from "../../../styles";
import {track} from "../../../misc/utils";

const handleZoomIn = () => state => {
  state.scale = Math.min(state.scale + 0.25, 2.25);
  state.pos.y =
    window.innerHeight / 25 * Math.sin(Math.PI / Math.min(2, state.scale));
  return state;
};

const handleZoomOut = () => state => {
  state.scale = Math.max(state.scale - 0.25, 1);
  state.pos.y =
    window.innerHeight / 25 * Math.sin(Math.PI / Math.min(2, state.scale));
  return state;
};

const bottleWrapperStyle = (scale, pos) => {
  return {
    transform: `scale(${scale}) translate(${pos.x}px, ${pos.y}px)`,
    transition: "transform 0.1s ease-in-out"
  };
};

class Desktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: 1,
      pos: { x: 0, y: 0 }
    };
  }

  render() {
    return (
      <Div css={styles.label.bottleContainer(this.props.method)}>
        <Button
          onClick={() => {
            track.event('button', 'click', 'preview_zoom_out');
            this.setState(handleZoomOut());
          }}
          css={styles.label.zoomOut}
        />
        <Div
          position="relative"
          css={bottleWrapperStyle(this.state.scale, this.state.pos)}
          display="inline-block"
        >
          <img
            alt=""
            style={styles.label.bottle(this.props.method)}
            src={this.props.bottleImage}
          />
          {this.props.children}
        </Div>
        <Button
          onClick={() => {
            track.event('button', 'click', 'preview_zoom_in');
            this.setState(handleZoomIn());
          }}
          css={styles.label.zoomIn}
        />
      </Div>
    );
  }
}

Desktop.propTypes = {
  bottleImage: PropTypes.string.isRequired
};

export default Desktop;



// WEBPACK FOOTER //
// ./src/components/areas/PreviewLabel/Desktop.js